const initialState = {
  loading: false,
  conversations: [],
  total: 0,
  connectedChannels: {},
  filters: { channel: 'all', account: null, status: 'all', search: '', limit: 30, skip: 0 },
  unreadTotal: 0,
  activeContactId: null,
  activeContact: null,
  contactLoading: false
};

const InboxReducer = (state = initialState, action) => {
  switch (action['type']) {
    case 'SET_INBOX_LOADING':
      return { ...state, loading: action['payload'] };

    case 'SET_INBOX_CONVERSATIONS': {
      const { conversations, total, connectedChannels, append } = action['payload'];
      return {
        ...state,
        loading: false,
        total: total ?? state['total'],
        connectedChannels: connectedChannels ?? state['connectedChannels'],
        conversations: append ? [...state['conversations'], ...conversations] : conversations
      };
    }

    case 'SET_INBOX_FILTERS':
      return { ...state, filters: { ...state['filters'], ...action['payload'] } };

    case 'SET_INBOX_UNREAD_TOTAL':
      return { ...state, unreadTotal: action['payload'] };

    case 'MARK_INBOX_ROW_READ':
      return {
        ...state,
        conversations: state['conversations'].map(c => c['contactId'] === action['payload'] ? { ...c, unreadCount: 0 } : c)
      };

    case 'MARK_INBOX_ROW_UNREAD':
      return {
        ...state,
        conversations: state['conversations'].map(c => c['contactId'] === action['payload'] ? { ...c, unreadCount: 1 } : c)
      };

    case 'SET_INBOX_CONTACT_LOADING':
      return { ...state, contactLoading: action['payload'] };

    case 'SET_INBOX_ACTIVE_CONTACT':
      return { ...state, activeContact: action['payload'], contactLoading: false };

    case 'SET_INBOX_ACTIVE_CONTACT_ID':
      return { ...state, activeContactId: action['payload'] };

    default:
      return state;
  }
};

export default InboxReducer;
